import { useAzureSearch } from './use-azure-search.hook';
import { IConfig } from '@vivli/shared/infrastructure/interface';

export const useStudiesSearch = (config: IConfig) => {
    return useAzureSearch({
        config,
        indexName: 'studies'
    });
};
